import { FormField } from "@/components/FormField";
import { SuggestionButton } from "@/features/identity/components/SuggestionButton";
import { websiteSuggestion } from "@/features/identity/validation";

export function ContactSection({ form }) {
  const { values, errors, onChange, setField } = form;
  const suggestion = errors.website ? websiteSuggestion(values.website) : null;
  return (
    <div className="grid gap-6">
      <FormField id="contact-email" name="email" type="email" label="Email" autoComplete="email" hint="Shown on your identity. This does not change your sign-in email." testId="contact-email-input" value={values.email} onChange={onChange} error={errors.email} />
      <FormField id="contact-phone" name="phone" type="tel" label="Phone" optional autoComplete="tel" placeholder="+1 555 123 4567" testId="contact-phone-input" value={values.phone} onChange={onChange} error={errors.phone} />
      <FormField
        id="contact-website"
        name="website"
        type="url"
        label="Website"
        optional
        autoComplete="url"
        placeholder="https://yourcompany.com"
        testId="contact-website-input"
        value={values.website}
        onChange={onChange}
        error={errors.website}
        hint={suggestion && <SuggestionButton value={suggestion} onApply={(v) => setField("website", v)} testId="contact-website-suggestion" />}
      />
    </div>
  );
}
